/* eslint no-eval: "off" */
import { useState, useEffect, useRef } from 'react';
import { Modal, ModalBody, ModalFooter } from '@lmig/lmds-react-modal';
import { Checkbox, CheckboxGroup } from '@lmig/lmds-react-checkbox';
import { Button } from '@lmig/lmds-react-button';
import { Link } from '@lmig/lmds-react-link';
import { triggerGoal, attachGoalsToLinks } from 'Utilities/GoalManager';
import Image from 'Foundation/GlassMapper/Image';
import './ContentModal.scss';
import { IModal } from '../Models/ContentModalModels';
import { GridCol, GridRow } from '@lmig/lmds-react-grid';

declare global {
  interface Window {
    Sitecore: any;
  }
}

const ContentModal = (props: IModal) => {
  /* when modal isnt rendered server side on page load, the dynamic placeholder 
  for the content also doesnt render. work around below loads modal on page by default as hidden and show/hides using css when in EE
  */
  const [isExperienceEditor] = useState<boolean>(window?.Sitecore?.PageModes?.PageEditor != undefined);
  const [isHidden, setIsHidden] = useState<boolean>(isExperienceEditor && props.isOpen == false);
  const kWidget = (window as any).kWidget;
  const [isOpen, setIsOpen] = useState(isExperienceEditor ? true : props.isOpen);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [modalHeight] = useState(null);
  const contentContainer = useRef<HTMLDivElement>(null);
  const innerChildren = useRef<any>(props.children ? props.children.replace(props.id, '') : null);

  //allow kaltura videos to play within modal
  useEffect(() => {
    try {
      if (innerChildren.current)
        if (isOpen) {
          let pRegex = innerChildren.current.match(/targetId':\s*'([^']+)/i);
          if (pRegex && pRegex.length > 1) {
            let playerId = pRegex[1];
            document.getElementById(playerId)?.remove();
          }
          let kalturaScript = innerChildren.current.match(/kWidget\.embed[\s\S]*\);/i);
          let script: string = '';
          if (kalturaScript && kalturaScript.length > 0) {
            script = kalturaScript[0];
          }
          if (script && script !== '' && kWidget) {
            eval(script);
          }
        }
    } catch (error) {
      console.error(error);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) triggerGoal(props.viewedGoal);
  }, [isOpen, props.viewedGoal]);

  useEffect(() => {
    if (contentContainer.current) {
      attachGoalsToLinks(contentContainer.current.querySelectorAll('a[goal]'));
    }
  }, [innerChildren.current]);

  const sendRequest = async () => {
    await fetch('/api/sitecore/PageContent/SaveModalHideOption', {
      method: 'POST',
      body: new URLSearchParams({ id: props.id, days: `${props.daysNotToShow}` }),
    })
      .then((res) => res.json())
      .then((res) => console.log(res));
  };

  const closeModal = (): void => {
    if (isExperienceEditor) setIsHidden(true);
    else {
      if (props.id !== null && (dontShowAgain || (props.daysNotToShow !== undefined && props.daysNotToShow == -1)))
        sendRequest();
      setIsOpen(false);
    }
  };

  const openModal = (): void => {
    setIsOpen(true);
    if (isExperienceEditor) setIsHidden(false);
  };

  return (
    <>
      {props.buttonText && !props.linkText && !props.image ? (
        <Button onClick={() => openModal()} variant="primary">
          {props.buttonText}
        </Button>
      ) : (
        <></>
      )}
      {props.linkText && !props.buttonText && !props.image ? (
        <Link onClick={() => openModal()} variant="standalone" style={{ padding: '1em' }}>
          {props.linkText}
        </Link>
      ) : (
        <></>
      )}
      {props.image && !props.buttonText && !props.linkText ? (
        <Image
          Alt={props.image.Alt}
          Class={props.image.Class ? props.image.Class + ' clickable-image' : 'clickable-image'}
          Height={props.image.Height}
          onClick={() => openModal()}
          Src={props.image.Src}
          Tabable={true}
          Title={props.image.Title}
          Width={props.image.Width}
        ></Image>
      ) : (
        <></>
      )}
      <Modal
        isOpen={isOpen}
        className={`content-modal ${isHidden ? 'hidden' : ''}`}
        size={props.size?.split(' ')[0]?.toLowerCase() as any}
        onClose={() => closeModal()}
        data-testid={props.id}
      >
        <ModalBody>
          <div
            style={{ minHeight: modalHeight ?? `${modalHeight}px`, display: 'flex' }}
            className={isOpen ? 'show' : ''}
            ref={contentContainer}
            dangerouslySetInnerHTML={{ __html: innerChildren.current }}
          ></div>
        </ModalBody>
        <ModalFooter>
          <GridRow gutterSize="fixed-16" gutters>
            <GridCol base={12}>
              <div className="modal-buttons">
                {props.dontShowAgain ? (
                  <CheckboxGroup>
                    <Checkbox
                      id={props.id}
                      labelVisual={props.dontShowAgain}
                      name="hideModalCheckbox"
                      value={props.dontShowAgain}
                      onChange={(e) => setDontShowAgain(e.target.checked)}
                      checked={dontShowAgain}
                    />
                  </CheckboxGroup>
                ) : (
                  <></>
                )}
                {props.closeButton ? (
                  <Button onClick={() => closeModal()} variant="primary">
                    {props.closeButton}
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            </GridCol>
          </GridRow>
        </ModalFooter>
      </Modal>
    </>
  );
};

ContentModal.defaultProps = {
  daysNotToShow: -1,
};

export default ContentModal;
